import { createAction } from '@reduxjs/toolkit';

import type { RootState } from '../../structureDefinitions/cartState';

export type CartState = RootState['cart'];

export const FULL_CART_ACTION_TYPE = 'cart/setFullCart';

export const setFullCart = createAction<CartState>(FULL_CART_ACTION_TYPE);
